module.exports = __webpack_public_path__ + "static/media/CaseNest_Purple_Negative_RGB.996cb6e6.svg";